import { makeStyles } from "tss-react/mui"
import { Box, Stack, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircle } from "@fortawesome/pro-solid-svg-icons"
import { ReactElement } from "react"
import { tailwindPalette } from "../../../modules/theme/tailwindPalette"

const useStyles = makeStyles()(() => ({
    cellIconDivider: {
        margin: "0 .5rem",
    },
    subtitle: {
        color: tailwindPalette.slate[500],
        fontSize: ".75rem",
    },
}))

type PropType = string | number | ReactElement

interface UniversalCellProps {
    title: PropType
    subtitle1: PropType
    subtitle2?: PropType | null
    subtitle3?: PropType | null
    subtitleClassName?: string
}

export function StandardTwoLinesCell({ title, subtitle1, subtitle2, subtitle3, subtitleClassName }: UniversalCellProps) {
    const { classes, cx } = useStyles()

    return (
        <Stack direction="column" spacing={1}>
            <Box>
                <Typography variant="body2">{title}</Typography>
            </Box>
            <Box className={cx(classes.subtitle, subtitleClassName)}>
                {subtitle1}
                {subtitle2 && (
                    <>
                        {subtitle1 && (
                            <FontAwesomeIcon className={classes.cellIconDivider} width=".25rem" icon={faCircle} />
                        )}
                        {subtitle2}
                    </>
                )}
                {subtitle3 && (
                    <>
                        {(subtitle1 || subtitle2) && (
                            <FontAwesomeIcon className={classes.cellIconDivider} width=".25rem" icon={faCircle} />
                        )}
                        {subtitle3}
                    </>
                )}
            </Box>
        </Stack>
    )
}
